module.exports = __webpack_public_path__ + "img/13.96f1d258.png";